<template>
    <el-carousel
        :interval="5000"
        arrow="hover"
        :height="height"
        indicator-position="none"
    >
        <el-carousel-item v-for="item in imgList" :key="item">
            <img :src="item" alt="bannner图" />
        </el-carousel-item>
    </el-carousel>
</template>

<script>
export default {
    data() {
        return {
            imgList: [
                require('../../../assets/img/common/banner1.png'),
                require('../../../assets/img/common/banner2.jpg'),
            ],
            height:0
        }
    },
     created() {
        let deviceWidth = document.documentElement.clientWidth
        this.height = deviceWidth*495/1903 + 'px'
    },
}
</script>
<style scoped lang="less">
.carousel-card {
    position: relative;
    height: 100%;
    > img {
        width: 100%;
        height: 100%;
    }
    &:hover {
        .carousel-title {
            display: flex;
        }
    }
}
.carousel-title {
    position: absolute;
    bottom: 0;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #fff;
    background: rgba(0, 0, 0, 0.5);
    font-size: 18px;
    display: none;
}
</style>
